if (!customElements.get('ib-theme-scroll')) {
  customElements.define('ib-theme-scroll', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const list = this.querySelector('.ibc-rail');
      const controls = this.querySelector('.ibc-rail-controls');
      const buttons = [...controls.querySelectorAll('button')];
      const update = () => {
        const max = list.scrollWidth - list.clientWidth;
        controls.hidden = max <= 2;
        buttons[0].disabled = list.scrollLeft <= 2;
        buttons[1].disabled = list.scrollLeft >= max - 2;
      };
      const move = direction => list.scrollBy({
        left: direction * (list.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(list).gap)),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), { signal }));
      list.addEventListener('keydown', event => {
        if (event.target !== list || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      list.addEventListener('scroll', update, { passive: true, signal });
      window.addEventListener('resize', update, { signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(list);
      }
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
